// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"06b10d99","303":"823e5759"}[chunkId] + ".chunk.css";
};